import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";

import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import { getCaseCategoryByCaseType } from "../../../../utils";
import { Label, Toaster } from "@fluentui/react-components";
import { makeStyles, tokens } from "@fluentui/react-components";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getPolicyCommissionDistributionDetailById,
  getPolicyCommissionDistributionListItems,
  getPolicyDetailById,
  getPolicyPaymentDetailById,
  getPolicyPaymentsCommissionDetailById,
  getPolicyPaymentsCommissionsListItems,
} from "../../../../redux/Case/policySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function PolicyCommissionDistribution({ tab }: { tab?: string }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, action, caseId, subItemId, subSubItemId, distributionId } =
    useParams();
  const [currentRecord, setCurrentRecord] = useState(1);

  const dispatch: AppDispatch = useDispatch();
  const policies = useSelector((state: RootState) => state.policies);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const [caseType, setCaseType] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>(tab || "distribution");
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId && subItemId && subSubItemId) {
      dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
      dispatch(getPolicyPaymentDetailById(subItemId));
      dispatch(
        getPolicyPaymentsCommissionsListItems({
          paymentId: subItemId,
          caseId,
          customerId: clientId,
        })
      );
      dispatch(
        getPolicyCommissionDistributionListItems({
          commissionId: subSubItemId,
        })
      );
    }
  }, [caseId, clientId, subItemId, subSubItemId, dispatch]);

  useEffect(() => {
    if (policies?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(policies.activeItem.case_type));
    }
  }, [policies?.activeItem]);

  useEffect(() => {
    if (subItemId && policies?.payments?.listItems?.length > 0) {
      dispatch(getPolicyPaymentDetailById(subItemId));
    }
  }, [subItemId, activeTab, policies?.payments?.listItems, dispatch]);

  useEffect(() => {
    if (
      subSubItemId &&
      policies?.payments?.commissions?.listItems?.length > 0
    ) {
      dispatch(getPolicyPaymentsCommissionDetailById(subSubItemId));
    }
  }, [
    subSubItemId,
    activeTab,
    policies?.payments?.commissions?.listItems,
    dispatch,
  ]);

  useEffect(() => {
    if (
      distributionId &&
      policies?.payments?.commissions?.distribution?.listItems?.length > 0
    ) {
      dispatch(getPolicyCommissionDistributionDetailById(distributionId));
    }
  }, [
    dispatch,
    subSubItemId,
    distributionId,
    activeTab,
    policies?.payments?.commissions?.distribution?.listItems,
  ]);

  const paymentId =
    subItemId || policies?.payments?.listItems[0]?.payment?.payment_id;
  const commissionId =
    subSubItemId ||
    policies?.payments?.commissions?.listItems[0]?.commission_id;
  const distributionID =
    distributionId ||
    policies?.payments?.commissions?.distribution?.listItems[0]
      ?.commission_allocation_id;

  useEffect(() => {
    if (!paymentId || !caseId || !commissionId || !distributionID) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/${distributionID}/distribution/view`
      );
    } else if (action === "add") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/add`
      );
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/${distributionID}/distribution/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/distribution/${distributionID}/distribution/view`
      );
    }
  }, [
    clientId,
    action,
    caseId,
    paymentId,
    commissionId,
    distributionID,
    policies?.payments?.commissions?.distribution?.listItems,
    tab,
    navigate,
  ]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="payments"
        section="policies"
        tab={activeTab}
        caseType={caseType}
        caseDetail={policies?.payments?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        {(action === "add" ||
          policies?.payments?.commissions?.distribution?.listItems?.length >
            0) && (
          <CaseForm
            mode={action || ""}
            section="policies"
            caseType={caseType}
            caseDetail={
              policies?.payments?.commissions?.distribution?.activeItem
            }
            caseItemList={
              policies?.payments?.commissions?.distribution?.listItems
            }
            tab={activeTab}
            subItem="payments"
            notify={showToast}
            currentRecord={currentRecord}
            setCurrentRecord={setCurrentRecord}
          />
        )}
        <div>
          {policies?.payments?.commissions?.distribution?.loading ? (
            <ContentLoader />
          ) : policies?.payments?.commissions?.distribution?.listItems?.length >
            0 ? (
            <CaseList
              module="distribution"
              data={policies?.payments?.commissions?.distribution?.listItems}
              activeItem={
                policies?.payments?.commissions?.distribution?.activeItem
              }
              section="policies"
              activeTab={tab}
              currentRecord={currentRecord}
              setCurrentRecord={setCurrentRecord}
            />
          ) : (
            action !== "add" && <NoDataFound />
          )}
        </div>
      </div>

      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={policies?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default PolicyCommissionDistribution;
